import React from 'react';

import { PromoGoToCart } from '../../../promo-go-to-cart/PromoGoToCart';

import './PromoSidecarCart.scss';

export const PromoSidecarCart = () => {

  return (
    <div className="promo-sidecar-cart-container">
      <PromoGoToCart />
    </div>
  );
};

PromoSidecarCart.displayName = 'PromoSidecarCart';
